<script lang="ts">
	import Time from './components/Time.svelte'
	import Weather from './components/Weather.svelte'

	const fetchWeather = (async () => {
		const response = await fetch('https://api.openweathermap.org/data/2.5/weather?q=fukuoka&appid=397973e1e0fd75daffdf4184d0080d65')
    return await response.json()
	})()

	let date = Date.now().toString()
	let version = date.substring(0, date.length - 4)

</script>

<svelte:head>
	<title>Vaapukka Cam</title>
	<meta name="robots" content="noindex nofollow" />
	<html lang="ja" />
</svelte:head>

<div class="wrapper">
	<main>
		<h1><Time /></h1>

		{#await fetchWeather}
			<p>...waiting</p>
		{:then data}
			<Weather data={data}/>
		{:catch error}
			<p>{error}</p>
		{/await}

	</main>
	<div class="bg"></div>

	<img class="blur" src="https://storage.googleapis.com/vaapukka-bucket/latest.jpg?{version}" alt=""/>
</div>

<style lang="scss">
	:global(*) {
		box-sizing: border-box;
	}
	:global(body) {
		position: relative;
		padding: 0;
	}
	.wrapper {
		position: relative;
		background-color: #000a;
		width: 100%;
		height: 100vh;
		overflow: hidden;
	}
	.blur {
			object-fit: cover;
			box-sizing: border-box;
			filter: blur(1px) brightness(1.5);

			position: absolute;
			top: -10vh;
			left: -10vw;
			width: 120vw;
			height: 120vh;
			border: 16px dotted orange;
			z-index: 0;

			content: '';
			user-select: none;
			pointer-events: none;
	}
	main {
		position: relative;
		background-size: contain;
		background-position: center;
		background-repeat: no-repeat;
		width: 100vw;
		height: 100vh;
		text-align: center;
		margin: 0 auto;
		z-index: 2;
	}

	h1 {
		color: #fff;
		text-transform: uppercase;
		font-size: 10vw;
		font-weight: 100;
		cursor: default;
		user-select: none;
    text-shadow: 0 0 2vmin #0004, 1px 1px 1px #0001;
	}

	// @media (min-width: 640px) {
	// 	main {
	// 		max-width: none;
	// 	}
	// }
</style>
